import { useState } from "react";
import { useLocalization } from "@fluent/react";
import { PreferenceContentCard } from "cerulean";

import ProfileSettingRow from "../ProfileSettingRow";
import PasswordEditDialog from "./PasswordEditDialog/PasswordEditDialog";

const PasswordInfoCard = () => {
  const { l10n } = useLocalization();
  const [isPasswordEditDialogOpen, setIsPasswordEditDialogOpen] =
    useState(false);

  return (
    <>
      <PreferenceContentCard
        title={l10n.getString("heading-password")}
        showSubtext={false}
        showToggle={false}
        content={
          <ProfileSettingRow
            label={l10n.getString("heading-password")}
            value="********************"
            editOnClick={() => {
              setIsPasswordEditDialogOpen(true);
            }}
            testId="password-setting"
          />
        }
      />
      <PasswordEditDialog
        isOpen={isPasswordEditDialogOpen}
        closeDialog={() => {
          setIsPasswordEditDialogOpen(false);
        }}
      />
    </>
  );
};

export default PasswordInfoCard;
